module.exports = __webpack_public_path__ + "static/media/viet1.9506a4ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/personal/thumbs/viet1.jpg
// module id = 470
// module chunks = 0